import React from 'react'
import { ResourceContextProvider } from 'react-admin'
import DiscountCreateClassic from '../DiscountCreate'

/**
 * `/discounts/create-classic`: o cadastro antigo, completo (Dotz, acréscimo, porcentagem). Fora do <Resource>,
 * o <Create> do react-admin não sabe de qual recurso é; o contexto resolve sem mexer no componente antigo.
 * A permissão `fuel-discounts` já é conferida dentro do DiscountCreate.
 */
const ClassicRoute: React.FC = () => (
  <ResourceContextProvider value="discounts">
    <DiscountCreateClassic />
  </ResourceContextProvider>
)

export default ClassicRoute
